module.exports = __webpack_public_path__ + "static/media/noti.1036984b.mp3";